module.exports = __webpack_public_path__ + "static/media/verda.56d84ab9.mp3";